<template>
  <div>
    <div class="forms">
      <div class="cards">
        <div class="subscription card full">
          <div class="number">
            <p>1</p>
          </div>
          <div class="inputs natural">
            <div class="input">
              <label>First Name</label>
              <input type="text" v-model="user.firstName" />
            </div>
            <div class="input">
              <label>Last Name</label>
              <input type="text" v-model="user.lastName" />
            </div>
            <div class="input">
              <label>Email Address</label>
              <input type="text" v-model="user.email" />
            </div>
            <div class="input">
              <label>Phone Number</label>
              <input type="tel" v-model="user.phone" />
            </div>
            <div class="input full">
              <label>Notes</label>
              <textarea v-model="user.notes"></textarea>
            </div>
          </div>
        </div>
        <template v-if="type == 'subscription'">
          <template v-if="subscription_data.quantity > 1">
            <div class="subscription card full">
              <div class="number">
                <p>2</p>
              </div>
              <div class="inputs">
                <div class="input full">
                  <label>I want them delivered</label>
                  <div class="btns">
                    <button
                      v-if="subscription_data.quantity < 3"
                      @click="delivered = 'Every 6 months'"
                      class="reverse_btn"
                      :class="{ active: delivered == 'Every 6 months' }"
                    >
                      Every 6 months
                    </button>
                    <button
                      v-if="subscription_data.quantity > 2"
                      @click="delivered = 'Every 4 months'"
                      class="reverse_btn"
                      :class="{ active: delivered == 'Every 4 months' }"
                    >
                      Every 4 months
                    </button>
                    <button
                      @click="delivered = 'All at once'"
                      class="reverse_btn"
                      :class="{ active: delivered == 'All at once' }"
                    >
                      All at once
                    </button>
                  </div>
                  <p class="dark">
                    (Delivery schedules can be amended within your account area)
                  </p>
                </div>
              </div>
            </div>
          </template>

          <!-- <div class='subscription card full'>
            <div class='number'>
              <p>2</p>
            </div>
            <div class='inputs'>
              <div class='input full'>
                <label>I am buying them for</label>
                <v-select
                :searchable='false'
                :clearable='false'
                v-model='buying'
                :options='["Myself", "Someone"]'>
                </v-select>
              </div>
            </div>
          </div> -->

          <div class="subscription card full">
            <div class="number">
              <p>{{ subscription_data.quantity > 1 ? "3" : "2" }}</p>
            </div>
            <div class="inputs">
              <div class="input full">
                <label>Do you have an existing 3D scan</label>
                <div class="btns">
                  <button
                    @click="subscription.has_scan = 1"
                    class="reverse_btn"
                    :class="{ active: subscription.has_scan }"
                  >
                    Yes
                  </button>
                  <button
                    @click="subscription.has_scan = 0"
                    class="reverse_btn"
                    :class="{ active: !subscription.has_scan }"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <button @click="verify()" class="btn finish">SAVE</button>
  </div>
</template>

<script>
export default {
  name: "info",
  props: ["type", "subscription_data"],
  data() {
    return {
      subscription: {
        delivery_frequency: "",
        checkout_in_place: true,
        has_scan: 1,
        is_trial: false,
      },
      buying: "Myself",
      delivered: "Every 6 months",
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        notes: "",
      },
      step: 1,
    };
  },
  created() {
    console.log(this.$parent.step);
  },
  methods: {
    verify() {
      let send = true;
      if (this.user.firstName.length < 1) {
        send = false;
        alert("Please enter a first name");
      }
      if (this.user.lastName.length < 1 && send) {
        send = false;
        alert("Please enter a last name");
      }
      if (this.user.phone.length < 1 && send) {
        send = false;
        alert("Please enter a phone number");
      }
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.user.email.toLowerCase()) && send) {
        send = false;
        alert("Please enter a valid email address");
      }
      if (send) {
        this.next();
      }
    },
    next(name, data) {
      let vm = this;
      this[name] = data;
      let num = this.step;
      this.step = null;
      setTimeout(function() {
        vm.$parent.step = num + 1;
        vm.submitPurchase();
      }, 500);
    },
    submitPurchase() {
      let vm = this;
      if (this.type == "subscription") {
        vm.$parent.popup = true;
        this.formatSubscriptionData();
      } else {
        vm.$emit("assignUserInfo", vm.user);
        vm.$parent.popup = true;
      }
    },
    formatSubscriptionData() {
      this.subscription.delivery_frequency =
        this.delivered == "Every 6 months"
          ? "distributed_evenly"
          : "all_at_once";
      this.subscription.payment_frequency = "annual";
      this.subscription.product_id = parseInt(
        this.$route.params.subscription.product_id
      );
      this.$emit("assignUserInfo", this.user, this.subscription);
    },
    toggle(choice, attribute) {
      if (this[attribute].includes(choice)) {
        let i = this[attribute].indexOf(choice);
        this[attribute].splice(i, 1);
      } else {
        this[attribute].push(choice);
      }
    },
  },
};
</script>

<style scoped>
.cards {
  flex-wrap: wrap;
}

.card {
  padding: 30px;
  margin-bottom: 20px;
}

.subscription {
  display: flex;
  justify-content: flex-start;
}

.subscription .inputs {
  width: 100%;
  margin-top: 5px;
}

.subscription .inputs .input {
  align-items: flex-start;
}

.subscription .inputs .input label {
  font-size: 28px;
}

.subscription .inputs.natural .input label {
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: bold;
}

.subscription .inputs.natural .input input {
  width: 100%;
}

.number {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(0, 0, 0, 0.32);
  border-radius: 100%;
  height: 40px;
  width: 40px;
  margin-right: 30px;
  flex: none;
}

.number p {
  font-size: 25px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.32);
}

.red_btn {
  background-color: #ef3b4b;
  color: white;
  font-size: 18px;
  padding: 12.5px 30px;
  min-width: auto;
  width: auto;
}

.reverse_btn {
  padding: 12.5px 30px;
  font-size: 17px;
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.22) !important;
  transition: background-color 0.3s, color 0.3s;
}

.btns {
  display: flex;
}

.btns button {
  margin-right: 20px;
}

.reverse_btn:hover,
.reverse_btn.active {
  background-color: #ef3b4b;
  color: white;
}

.dark {
  background: #364a5e;
  color: white;
  padding: 10px 20px;
}
</style>
